import React, { createContext, useReducer, useState } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import AppReducer from './AppReducer';

export const GlobalContext = createContext();

const GlobalProvider = ({ children }) => {
  const [isScroll, setIsScroll] = useState(true);
  const [timestamp, timestampDispatch] = useReducer(AppReducer, '');
  const [openSubscribeAlert, setOpenSubscribeAlert] = useState(false);
  const [subscribeError, setSubscribeError] = useState('');

  const expirationDate = (timestamp) => {
    timestampDispatch({
      type: 'GET_TIMESTAMP',
      payload: timestamp,
    });
  };

  return (
    <GlobalContext.Provider
      value={{
        timestamp,
        expirationDate,
        isScroll,
        setIsScroll,
        openSubscribeAlert,
        setOpenSubscribeAlert,
        subscribeError,
        setSubscribeError,
      }}
    >
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        {children}
      </MuiPickersUtilsProvider>
    </GlobalContext.Provider>
  );
};
export default GlobalProvider;
